export default __webpack_public_path__ + "static/media/4.50ac17fe.png";